import { Button, IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import { CheckCircleRounded, CloseRounded, Visibility } from '@material-ui/icons';
import Axios from 'axios';
import React, { Component, Fragment } from 'react';
import Currency from '../../../../commonModules/Currency';
import Dialog from '../../../../commonModules/interface/Dialog';
import InputText from '../../../../commonModules/interface/form-input-inline';
import FactureComptaPopUp from './FactureComptaPopUp';


export class FactList extends Component {
    state = { 
        showFactures : false,
        spendingID: "",
        factExist: {}

    }
    componentDidMount = () =>{
        this.checkFactID()
    }
    checkFactID = () => {
        const { fact_id_5000 } = this.props;
        let factExist = {}
        let config = {
            headers: {
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
            }
        }
        fact_id_5000.split(",").forEach( async spendingID => {
            console.log({spendingID});
            if (!factExist[spendingID]) {
                const res = await Axios.post("/stocks/compta/spendings/single", {spendingID}, config)
                console.log({res});
                if (res.data && res.data.spending_id != "") {
                    factExist[spendingID] = res.data
                }
            }
            console.log("checkFactID", {factExist});
            this.setState({
                factExist,
            })
        })
        this.setState({
            showFactures : true
        })
    }
    render() {
        const { fact_id_5000} = this.props;
        const { spendingID, factExist } = this.state;
        return (
            <Dialog 
                title="Voir les factures"
                block={true}
                close={this.props.handleClose}
                maxWidth="md"
            >
                {spendingID && factExist[spendingID] &&
                    <FactureComptaPopUp 
                        spendingID={spendingID} 
                        spending ={factExist[spendingID]}
                        handleClose={() => this.setState({ spendingID: ""})}
                    />
                }
                <List >
                    {fact_id_5000.split(",").map( fact => 
                        <ListItem button onClick={() => this.setState({ spendingID: fact})}> 
                            <ListItemIcon>
                                {factExist[fact] ?
                                    <CheckCircleRounded color="primary"/>
                                    :
                                    <CloseRounded color="error" />
                                }
                            </ListItemIcon>
                            <ListItemText
                                primary={fact}
                                secondary={factExist[fact] && factExist[fact].spending_desc}
                            />
                            {factExist[fact] &&
                            <ListItemSecondaryAction>
                                <ListItemText
                                    primary={<Currency value={factExist[fact] && factExist[fact].spending_amountTTC}/>}
                                    // secondary={
                                    //     <IconButton edge="end">
                                    //         <VisibilityRounded />
                                    //     </IconButton>
                                    // }
                                />
                            </ListItemSecondaryAction>
                            }
                        </ListItem>
                    )}
                </List>
            </Dialog>
        );
    }
}

class InputFactID extends Component {
    state = { 
        showFactures : false,
        spendingID: "",
        factExist: {}

    }
    checkFactID = () => {
        const { fact_id_5000, type } = this.props;
        let factExist = {}
        let config = {
            headers: {
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
            }
        }
        fact_id_5000.split(",").forEach( async factID => {
            console.log({ factID, type });
            if (!factExist[factID]) {
                if (type === "purchase") {
                    const res = await Axios.post("/stocks/compta/spendings/single", {spendingID: factID}, config)
                    console.log({res});
                    if (res.data && res.data.spending_id) {
                        factExist[factID] = res.data
                        factExist[factID].type = "spending"
                    }
                } else {
                    // const res = await this.props.getIncomeInfo(factID)
                    // console.log('====================================');
                    // console.log({res});
                    // console.log('====================================');
                    // if (!res.error && res.income_amount !== 0) {
                    //     factExist[factID] = res.data
                    // } 
                    const res = await Axios.post("/money/get/income/info", {incomeID: factID}, config)
                    console.log({res});
                    if (res.data && res.data.income_amount !== 0) {
                        factExist[factID] = res.data
                        factExist[factID].type = "income"
                    }
                }
            }
            console.log("checkFactID", {factExist});
            this.setState({
                factExist,
            })
        })
        this.setState({
            showFactures : true
        })
    }
    render() {
        const { error, fact_id_5000} = this.props;
        const { showFactures, spendingID, factExist } = this.state;
        // console.log('=================STATE===================');
        // console.log(this.state);
        // console.log('====================================');
        // let mapLines = []
        // for (let i = 1; i <= numberProd; i++){
        //     mapLines.push(i)
        // }
        
        return (
            <Fragment>
                {showFactures &&
                    <Dialog 
                        title="Voir les factures"
                        block={true}
                        close={() => this.setState({ showFactures : false })}
                        maxWidth="md"
                    >
                        {spendingID && factExist[spendingID] &&
                            <FactureComptaPopUp 
                                spendingID={spendingID} 
                                spending={factExist[spendingID]}
                                handleClose={() => this.setState({ spendingID: ""})}
                                // type={this.props.type}
                            />
                        }
                        <List >
                            {fact_id_5000.split(",").map( fact => 
                                <ListItem button onClick={() => this.setState({ spendingID: fact})}> 
                                    <ListItemIcon>
                                        {factExist[fact] ?
                                            <CheckCircleRounded color="primary"/>
                                            :
                                            <CloseRounded color="error" />
                                        }
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={fact}
                                        secondary={factExist[fact] && (factExist[fact].spending_desc || factExist[fact].income_desc  )}
                                    />
                                    {factExist[fact] &&
                                    <ListItemSecondaryAction>
                                        <ListItemText
                                            primary={<Currency value={factExist[fact] && (factExist[fact].spending_amountTTC || factExist[fact].income_amount )}/>}
                                            // secondary={
                                            //     <IconButton edge="end">
                                            //         <VisibilityRounded />
                                            //     </IconButton>
                                            // }
                                        />
                                    </ListItemSecondaryAction>
                                    }
                                </ListItem>
                            )}
                        </List>
                    </Dialog>
                }
                <InputText 
                    type="text" 
                    id="fact_id_5000" 
                    onChange={this.props.handleChange} 
                    value={fact_id_5000} 
                    name="fact_id_5000" 
                    title="N° Facture 5000"
                    helperText="Si plusieurs: séparer par une virgule sans espaces (12334,23455,45645...) "
                    error={error}
                    rows={3}
                />
                {/* {mapLines.map( i =>
                    <InputText 
                        type="text" 
                        id={"fact_id_5000_"+i}
                        onChange={this.props.handleChange} 
                        value={fact_id_5000} 
                        name={"fact_id_5000_"+i}
                        title={"Facture 5000 " + i}
                        // helperText="Si plusieurs: séparer par une virgule sans espaces (12334,23455,45645...) "
                        error={error}
                        // rows={3}
                    />
                )} */}
                {/* <Button onClick={() => this.setState({ numberLine : numberLine ++})}>Ajouter</Button> */}
                { fact_id_5000 &&
                    <Button
                        startIcon={<Visibility />}
                        onClick={this.checkFactID} color="secondary"
                    >
                        Aperçu
                    </Button>
                }
            </Fragment>
        );
    }
}

export default InputFactID;